import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'

export const TextHeroDesktop: ComponentType<{ title?: string, subtitle?: string }> = ({ title, subtitle }) => (
    <div className="py-160 bg-blue-zodiac-95 rounded-lg">
        <Container>
            <Row>
                <Col>
                    <h1 className="text-center font-family-open-sans font-weight-bold text-shadow text-white mb-15">
                        {title || "Hello"}
                    </h1>
                    <h2 className="text-center font-family-open-sans font-weight-bold text-anakiwa font-size-base text-shadow mb-0">
                        {subtitle || "Hello"}
                    </h2>
                </Col>
            </Row>
        </Container>
    </div>
)
